import React from 'react';
import PropTypes from 'prop-types';
import styled, { useTheme } from 'styled-components';

// A contact's aggregate reachability across all of a team's connections to them
// (Figma "Reachability badge"). Distinct from a single intro path's relationship
// strength: the bars/colours match (high≡3 green, medium≡2 orange, low≡1 blue,
// none≡0 grey) but the scale is High/Medium/Low/None.
export const REACH_LEVELS = ['high', 'medium', 'low', 'none'];

const VIEWBOX_SIZE = 16;

const BARS = [
  { x: 1.5, y: 3, width: 3, height: 10, rx: 1.5 },
  { x: 6.5, y: 3, width: 3, height: 10, rx: 1.5 },
  { x: 11.5, y: 3, width: 3, height: 10, rx: 1.5 },
];

const LEVEL_CONFIG = {
  high: { activeBars: 3, activeColor: ['green', 600] },
  medium: { activeBars: 2, activeColor: ['orange', 600] },
  low: { activeBars: 1, activeColor: ['blue', 600] },
  none: { activeBars: 0 },
};

const Svg = styled.svg`
  display: block;
  flex-shrink: 0;
`;

const ReachabilityIndicator = ({ level, size, className, title }) => {
  const theme = useTheme();
  const effectiveLevel = LEVEL_CONFIG[level] ? level : 'none';
  const { activeBars, activeColor } = LEVEL_CONFIG[effectiveLevel];
  const inactiveColor = theme.colors.neutral[100];
  const fillActive = activeColor ? theme.colors[activeColor[0]][activeColor[1]] : inactiveColor;

  return (
    <Svg
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
      role="img"
      aria-label={title || `${effectiveLevel} reachability`}
      data-reachability={effectiveLevel}
    >
      {BARS.map((bar, index) => (
        <rect key={bar.x} {...bar} fill={index < activeBars ? fillActive : inactiveColor} />
      ))}
    </Svg>
  );
};

ReachabilityIndicator.propTypes = {
  level: PropTypes.string.isRequired,
  size: PropTypes.number,
  className: PropTypes.string,
  title: PropTypes.string,
};

ReachabilityIndicator.defaultProps = {
  size: 16,
  className: undefined,
  title: undefined,
};

export default ReachabilityIndicator;
